/* eslint-disable no-extra-boolean-cast */
import React, { useRef, useState } from 'react'
import { Dropdown, Form } from 'react-bootstrap'
import { Controller } from 'react-hook-form'
import Select, { components, OptionProps } from 'react-select'
const DropDownControlForCategery = ({
    label,
    options,
    error,
    control,
    name,
    isDisabled,
    showLabel = true,
    getCategory = () => {},
    id
}) => {
    const { Option } = components

    const IconOption = (props) => {
        const { label, categoryName } = props.data
        return (
            <Option {...props}>
                <div className="react-select-option">{categoryName}</div>
            </Option>
        )
    }
    const validateString = (value) => {
        try {
            if (!!JSON.parse(value).name) {
                return JSON.parse(value).name
            } else {
                return label
            }
        } catch (error) {
            return value
        }
    }

    const refReactSelect = useRef(null)
    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            // const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor: isFocused ? '#814b99' : null,
                color: isFocused ? 'white' : 'black',
                cursor:'pointer',
                ':active': {
                    backgroundColor: '#814b99'
                }
            }
        }
    }
    return (
        <>
            {showLabel ? (
                <Form.Label className="lcontrol">{label}</Form.Label>
            ) : (
                ''
            )}
            <Controller
                control={control}
                name={name}
                render={({ field: { value, onChange, ref } }) => {
                    return (
                        <>
                            <Select
                            isDisabled={isDisabled}
                                value={
                                    !!value?.categoryName && !!value?.categoryId
                                        ? value
                                        : null
                                }
                                // backspaceRemovesValue={false}
                                // isClearable={false}
                                // isDisabled={id ? false : true}
                                styles={{
                                    indicatorSeparator: (base) => ({
                                        ...base,
                                        display: 'none'
                                    }),
                                    ...colourStyles
                                }}
                                // controlShouldRenderValue={false}
                                onChange={(e) => {
                                    onChange(e)
                                    getCategory(e)
                                }}
                                maxMenuHeight={150}
                                // placeholder='Select Country'
                                getOptionLabel={(erty) => {
                                    return erty.categoryName
                                }}
                                getOptionValue={(ert) => {
                                    return ert.categoryName
                                }}
                                name="react-selectpreferredIndustry"
                                className="basic-multi-select "
                                classNamePrefix="select"
                                options={options}
                                components={{ Option: IconOption }}
                            />
                            {error && (
                                <span
                                    className="error-message"
                                    style={{ color: 'red' }}
                                >
                                    {error}
                                </span>
                            )}
                        </>
                    )
                }}
                onFocus={() => refReactSelect.current.focus()}
            />
        </>
    )
}

export default React.memo(DropDownControlForCategery)
